import { getFacebookIntegrationStatus } from '../../services/integration.service';
import { getAllLabels, getAllLibraries } from '../../services/postTracking.service';
import {
  SET_LABELS,
  SET_LIBRARIES,
  TOGGLE_LOADING_LABELS,
  TOGGLE_LOADING_LIBRARIES,
  UPDATE_INSTAGRAM_CONNECTION_STATUS,
} from './socialListeningTypes';

export const updateInstagramConnectionStatus = (connected) => {
  return {
    type: UPDATE_INSTAGRAM_CONNECTION_STATUS,
    payload: connected,
  };
};

export const fetchInstagramConnectionStatus = () => {
  return async (dispatch) => {
    const res = await getFacebookIntegrationStatus();
    dispatch(updateInstagramConnectionStatus(!!res?.data?.success));
    if (res?.data?.error) {
      throw new Error(res?.data?.message);
    }
  };
};

export const fetchPostTrackingLabels = () => async (dispatch) => {
  dispatch({ type: TOGGLE_LOADING_LABELS, payload: true });
  const response = await getAllLabels();
  dispatch({ type: TOGGLE_LOADING_LABELS, payload: false });
  if (response?.status) {
    dispatch({
      type: SET_LABELS,
      payload: response.data,
    });
  }
};

export const fetchPostTrackingLibraries =
  (page = 1, limit = 9, evict = false) =>
  async (dispatch) => {
    const key = `${page}-${limit}`;
    dispatch({ type: TOGGLE_LOADING_LIBRARIES, payload: true });
    const response = await getAllLibraries({ limit, page });
    if (response?.status) {
      dispatch({
        type: SET_LIBRARIES,
        payload: { evict, key, data: response?.data?.libraries, totalPages: response?.data?.totalPages },
      });
    }
  };